module.exports = __webpack_public_path__ + "static/media/imgChat.ff02c3fe.svg";